// extracted by mini-css-extract-plugin
export default {"nav_width_65":"Pages_nav_width_65__CS6sH","ml_2":"Pages_ml_2__gF1OG","successMsg":"Pages_successMsg__9Px66","Underline":"Pages_Underline__VRBol","formBox":"Pages_formBox__CLg+9"};